var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20_911",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20_911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2778 14.4637C12.7636 14.9495 12.7636 15.7823 12.2778 16.2681L11.2715 17.2744C10.7857 17.7603 9.9529 17.7603 9.46709 17.2744L5.06015 12.8328C4.57435 12.347 4.57435 11.5142 5.06015 11.0284L6.06646 10.0221C6.55227 9.53628 7.38508 9.53628 7.87088 10.0221L12.2778 14.4637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1298 6.79496C16.6156 6.30915 17.4484 6.30915 17.9342 6.79496L18.9405 7.80127C19.4263 8.28707 19.4263 9.11988 18.9405 9.60568L11.3064 17.2051C10.8206 17.6909 9.98781 17.6909 9.50201 17.2051L8.4957 16.1987C8.0099 15.7129 8.0099 14.8801 8.4957 14.3943L16.1298 6.79496Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/CheckCircle.c385f76a41f5e84b16c3a3d4e0129e7d.svg";
export { ForwardRef as ReactComponent };